import { env } from '@/env'

export const twitterPostLink = env.app.isProd ? 'https://r.dropee.xyz/xpost' : 'https://rdev.dropee.xyz/xpost'
